var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.102.925 8.009 7.89q.29.285.289.692a.93.93 0 0 1-.289.692l-.908.895a1.04 1.04 0 0 1-.702.305.9.9 0 0 1-.702-.265L9.4 4.83 3 11.134a.9.9 0 0 1-.7.265 1.04 1.04 0 0 1-.703-.305l-.908-.895A.93.93 0 0 1 .4 9.507q0-.405.289-.691l8.01-7.89A.9.9 0 0 1 9.4.6q.413 0 .702.325"
  })));
};
export default SvgChevronUp;